import { useState } from 'react';
import { useInView } from 'react-intersection-observer';

import toast from 'react-hot-toast';

import { deleteImage } from '../../lib';

import { useMutation } from '@tanstack/react-query';

export default function ImageCard({ image, endpoints, imagePreviewModalId, setImagePreview, authToken, onDeleteImageCallback }) {
  const { name, url, id } = image;
  const { ref, inView } = useInView({
    triggerOnce: true,
    fallbackInView: true,
  });

  const [isDeleting, setIsDeleting] = useState(false);

  const handleImagePreview = () => {
    setImagePreview(url);
  };

  const deleteMutation = useMutation({
    mutationFn: () => deleteImage(authToken, id),
    onMutate: () => {
      setIsDeleting(true);
    },
    onSuccess: () => onDeleteImageCallback(id),
    onError: (error) => toast.error(`Failed to delete image: ${name} | ${error.message}`),
    onSettled: () => {
      setIsDeleting(false);
    },
  });

  return (
    <div className="image-card">
      <div className="top-bar">
        <label className="image-name" data-bs-toggle="tooltip" data-bs-title={name}>
          {name}
        </label>
        <div className="dropdown">
          <button className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i className="fe fe-more-horizontal" />
          </button>
          <ul className="dropdown-menu">
            <li>
              <div className="dropdown-item d-flex flex-column gap-2 text-muted">
                <b>Name</b>
                <span>{name}</span>
              </div>
            </li>
            <li className="dropdown-divider">
              <hr />
            </li>
            <li>
              <button
                type="button"
                className="dropdown-item d-flex gap-2"
                onClick={() => {
                  navigator.clipboard.writeText(id);
                  toast('Image ID copied to clipboard');
                }}
              >
                <i className="fe fe-copy" />
                Copy ID
              </button>
            </li>
            <li>
              <a className="dropdown-item" href={`${endpoints.newAdminImageUrl}?img_src=${url}&filename=${name}`}>
                Edit
              </a>
            </li>
            <li className="dropdown-divider">
              <hr />
            </li>
            <li>
              <button className="dropdown-item" onClick={() => deleteMutation.mutate()} disabled={isDeleting}>
                {isDeleting ? 'Deleting...' : 'Delete'}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <button className="image-container-button" data-bs-toggle="modal" data-bs-target={`#${imagePreviewModalId}`} onClick={handleImagePreview}>
        <div ref={ref} className="image-container">
          {url ? (
            inView ? (
              <>
                <img src={url} alt={`Image ID: ${id}`} />
                <div className="overlay">
                  <i className="fe fe-eye" />
                </div>
              </>
            ) : (
              <div className="preview-container">
                <i className="fe fe-file" />
              </div>
            )
          ) : (
            <div className="preview-container">CDN URL is not found.</div>
          )}
        </div>
      </button>
      {isDeleting && (
        <div className="image-card-deleting-overlay">
          <div className="spinner-border" role="status" style={{ width: '2.5rem', height: '2.5rem' }}>
            <span className="visually-hidden">Deleting</span>
          </div>
          <span className="deleting-text">Deleting</span>
        </div>
      )}
    </div>
  );
}
